<template>
    <div class="mine-serve">
        <div class="mine-serve-header flex">
            <img class="mine-serve-title-image" src="@/assets/images/user/serve.png" alt="" />
            <p class="mine-serve-title">我的服务</p>
        </div>
        <div class="mine-serve-wrap">
            <div class="mine-serve-item flex flex-column justify-center align-center" v-for="(item, index) in dataList" @click="handleItem(item)" :key="index">
                <img :src="item.icon" alt="" />
                <p>{{ item.name }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { zzconfig } from "@/config/zzconfig";
import { obj2Param } from "@/libs/tools";
import { getMerchantCanUse } from '@/api/api'
import { mapGetters } from "vuex";

export default {
    name: "MineServe",
    data() {
        return {
            dataList: [
                // {
                //     icon: require("@/assets/images/user/privacy.png"),
                //     name: "",
                //     route: "/privacyService",
                // },

                {
                    icon: require("@/assets/images/user/server.png"),
                    name: "客服热线",
                    route: "/serverTel",
                },
                {
                    icon: require("@/assets/images/user/bill.png"),
                    name: "电子发票",
                    route: "/invoice",
                },
                {
                    icon: require("@/assets/images/user/operationGuide.png"),
                    name: "操作指南",
                    route: "/operationGuide",
                },
                {
                    icon: require("@/assets/images/user/suggestion.png"),
                    name: "客服帮助",
                    route: "/suggestion",
                },
                {
                    icon: require("@/assets/images/user/myCall.png"),
                    name: "我的申诉",
                    route: "/suggestion/complainHtistory",
                },
                {
                    icon: require("@/assets/images/user/usercenter.png"),
                    name: "个人设置",
                    route: "/mine/userinfo",
                },

                {
                    icon: require("@/assets/images/user/public.png"),
                    name: "优惠认证",
                    route: "/mine/preferentialCertification",
                },


            ],
        };
    },
    computed: {
        ...mapGetters({ tokenIsUseful: "tokenIsUseful" }),
    },
    methods: {
        handleItem(item) {
            if (item.route == "/serverTel") {
                window.location.href = `tel:${zzconfig.PHONE}`;
                return;
            } else if (item.route == "/invoice") {
                let obj = {
                    token: localStorage.getItem("token"),
                    userId: localStorage.getItem("userId"),
                    xcxOpenId: localStorage.getItem("openId"),
                };
                let str = `${process.env.VUE_APP_BASE_API}qgvip/elecTicket/electronicTicketHome?${obj2Param(obj)}`;
                wx.miniProgram.navigateTo({
                    url: `/pages/tab2/webview/webview?jumpUrl=${encodeURIComponent(str)}`,
                });
            } else {
                this.$router.push(item.route);
            }
        },
    },
    mounted() {
        if (!this.tokenIsUseful) return
        getMerchantCanUse().then(res => {
            if (res.data == 1) {
                this.dataList.push({
                    icon: require("@/assets/images/user/payment.png"),
                    name: "代付充值",
                    route: "/mine/paymentWallet",
                })
            }
        })
    }
};
</script>

<style lang="less" scoped>
.mine-serve {
    width: 702px;
    min-height: 256px;
    background: #ffffff;
    border-radius: 16px;
    // display: flex;
    // flex-direction: column;
    padding-bottom: 20px;
    .mine-serve-header {
        padding: 24px 32px;
        .mine-serve-title-image {
            width: 32px;
            height: 32px;
            margin-right: 16px;
        }
        .mine-serve-title {
            color: #666666;
            font-size: 26px;
        }
    }
    .mine-serve-wrap {
        // flex: 1;
        display: flex;
        flex-wrap: wrap;
        // justify-content: center;
        // align-items: center;
        // flex-direction: ;
        .mine-serve-item {
            // flex: 1;
            height: 160px;
            width: 33%;

            img {
                width: 64px;
                height: 64px;
                margin-bottom: 16px;
            }
            p {
                color: #999;
                font-size: 26px;
            }

            &:nth-child(2) {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    left: 0;
                    width: 1px;
                    height: 130px;
                    background: #666666;
                    opacity: 0.1;
                    border-radius: 1px;
                }
                &::before {
                    content: "";
                    position: absolute;
                    right: 0;
                    width: 1px;
                    height: 130px;
                    background: #666666;
                    opacity: 0.1;
                    border-radius: 1px;
                }
            }

            &:nth-child(5) {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    left: 0;
                    width: 1px;
                    height: 130px;
                    background: #666666;
                    opacity: 0.1;
                    border-radius: 1px;
                }

                &::before {
                    content: "";
                    position: absolute;
                    right: 0;
                    width: 1px;
                    height: 130px;
                    background: #666666;
                    opacity: 0.1;
                    border-radius: 1px;
                }
            }
        }
    }
}
</style>
